<template>
    <p class="text-danger">
        <i class="bi bi-exclamation-circle" :class="optional_class"></i>
        <slot/>
    </p>
</template>

<script>
export default {
    name: 'TextWarn',
    props: {
        optional_class: {
            type: String,
            default: ''
        },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    p {font-size: .9rem; text-indent: -0.8rem; padding-left: 1.8rem;}
    .bi {margin-right: .5rem;}
</style>
